<template>
  <div class="app-list">
     <el-form :model="formData"  label-width="90px">
        <el-form-item label="产品:" required>
            <ListCheck v-model="formData.appId" @change="handleAppChange" :list="aiLaunchGlobal.appList">
                <template #default="{ row }">
                    <p>{{row.app_name}}({{row._app_id}})</p>
                    <span>计划数：{{ appPlatNumData[row.app_id] }}</span>
                </template>
            </ListCheck>
        </el-form-item>
     </el-form>
  </div>
</template>

<script>
import ListCheck from './listCheck.vue'
import busMixin from '@/views/mixins/busMixin'
import _ from 'lodash'
export default {
    components: { ListCheck },
    inject: [ 'aiLaunchGlobal' ],
    mixins: [ busMixin ],
    data() {
        return {
            formData: {  }
        }
    },
    methods: {
         handleAppChange(data) {
            const appData = _.find(this.aiLaunchGlobal.appList, { app_id: data });
            this.$bus.$emit('updataFormNameData', appData?.app_name || '');
         }
    },
    computed: { 
        appPlatNumData() {
            return this.aiLaunchGlobal.appList.reduce((pre, cur)=> {
                const data = this.aiLaunchGlobal.appMaterialDataResult[cur.app_id] || {}
                pre[cur.app_id] =data.platNum || '-';
                return pre;
            }, {})
        },
    },
    mounted() {
        this.createBus('updataFormData', (data)=> {
            if(data) {
                this.formData = { ...data }
            }
        })
    },
    watch: {
        'formData.appId'(n) {
            this.$emit('update:appId', n)
        }
    },

}
</script>

<style lang="scss" scoped>

</style>